
import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import type { HotOffer } from '@shared/api/types/hotOffers';
import NextLink from '@shared/common/components/NextLink';

import { useHotOfferStats } from '../HotOffersPage/HotOfferStats';

interface UserHotOfferCardProps {
  className?: string;
  offer: HotOffer;
}

const UserHotOfferCard = ({ className, offer }: UserHotOfferCardProps) => {
  const stats = useHotOfferStats(offer);

  return (
    <div
      className={classNames(
        'flex gap-4 rounded-lg shadow-main p-4 items-start overflow-hidden',
        className,
      )}
      data-qa="claimed-hot-offer"
    >
      <NextLink href={`/hot-offers/${offer.id}`} className="flex-shrink-0">
        <ImageProxy
          width={64}
          height={64}
          alt={`${offer.attributes.name}'s icon`}
          src={offer.attributes.icon}
          className="rounded-full size-[52px] md:size-16  bg-neutral-100"
        />
      </NextLink>
      <div className="flex flex-col gap-1 overflow-hidden">
        <NextLink href={`/hot-offers/${offer.id}`} className="font-semibold text-sm truncate">
          {offer.attributes.name}
        </NextLink>
        <ul className="flex gap-x-2 gap-y-1 items-center text-xs font-semibold flex-wrap">
          {stats.map(({ id, Icon, content }) => {
            return (
              <li key={id} className="flex gap-2 items-center">
                {Icon && <Icon className="icon-xs" />}
                {content}
              </li>
            );
          })}
        </ul>
        <span className="font-light text-xs text-[#918FA0] truncate">{offer.attributes.offer}</span>
      </div>
    </div>
  );
};

export default UserHotOfferCard;
